import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private _active = false;
  private _searchTerm = '';
  doSearch = new EventEmitter<string>();
  doReset = new EventEmitter();

  constructor() {
  }

  get active(): boolean {
    return this._active;
  }

  set active(value: boolean) {
    this._active = value;
  }

  get searchTerm(): string {
    return this._searchTerm;
  }

  set searchTerm(value: string) {
    this._searchTerm = value;
    this.doSearch.emit(this._searchTerm);
  }

  reset() {
    this.doReset.emit();
  }
}
